var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOasispro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 41,
    viewBox: "0 0 44 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_841_3839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.3084 7.8959C32.2654 7.98056 33.1684 10.9435 34.3509 14.4991C35.5119 18.0546 36.4794 21.0811 36.4794 21.2081C36.4794 21.4197 35.4689 21.4832 32.1149 21.4832H27.7504L27.2559 22.9859C26.9979 23.8112 26.8044 24.5308 26.8689 24.5943C26.9334 24.6366 29.3844 24.679 32.3299 24.679L37.6834 24.6578L38.9519 28.4673L40.1989 32.2769H41.9834H43.7464L42.7144 29.1657C41.0589 24.171 38.9949 17.8853 37.5759 13.5467C36.8449 11.3245 36.0924 9.12342 35.9204 8.61548L35.5764 7.72659H34.0069C33.1254 7.72659 32.3729 7.79008 32.3084 7.8959Z",
    fill: "#545B6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1741 8.34044C4.3151 9.86425 1.0041 14.605 0.939604 20.1076C0.918104 22.6685 1.1976 23.9807 2.3371 26.3087C3.9926 29.7584 7.1961 32.1711 10.8081 32.7002C16.2046 33.5256 21.5151 29.7796 23.1276 24.023C23.9876 20.9965 23.6436 17.1447 22.2676 14.4357C20.7411 11.4092 18.7416 9.56796 15.7101 8.44626C13.9686 7.81134 11.0231 7.74785 9.1741 8.34044ZM15.3016 11.7267C17.4946 12.7637 19.0856 14.5838 19.9456 17.06C20.5691 18.859 20.5906 21.6949 19.9886 23.515C19.1286 26.0971 17.0431 28.3828 14.7426 29.2293C13.2161 29.8008 10.8296 29.7161 9.3461 29.06C5.0891 27.1341 2.9821 21.7161 4.6591 16.933C5.5406 14.4145 7.0671 12.7214 9.3891 11.6632C11.1521 10.859 13.5171 10.8801 15.3016 11.7267Z",
    fill: "#545B6C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_841_3839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 40,
    fill: "white",
    transform: "translate(0.789062 0.319336)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOasispro);
export default __webpack_public_path__ + "static/media/oasispro.b0e9cc99f76666c16a974f82de95e4b9.svg";
export { ForwardRef as ReactComponent };